const formatNum = (num) => {
    return new Intl.NumberFormat("fr-FR").format(num);
};

const formatNumber = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export default formatNumber